import type Token from "markdown-it/lib/token.mjs";
import markdownit from "markdown-it";

export interface TextNode {
  type: "text";
  content: string;
}

export interface ElementNode {
  type: string; // e.g. 'paragraph_open', 'bullet_list_open', …
  tag: string; // the actual HTML tag, e.g. 'p', 'ul'
  attrs?: [string, string][];
  children: MarkdownAstNode[];
}

export type MarkdownAstNode = TextNode | ElementNode;

function toAst(tokens: Token[]): ElementNode {
  const root: ElementNode = { type: "root", tag: "", children: [] };
  const stack: ElementNode[] = [root];

  for (const t of tokens) {
    if (t.nesting === 1) {
      const el: ElementNode = {
        type: t.type,
        tag: t.tag,
        attrs: t.attrs ?? undefined,
        children: [],
      };
      stack[stack.length - 1].children.push(el);
      stack.push(el);
    } else if (t.nesting === 0) {
      if (t.type === "inline" && t.children) {
        // recurse over inline token list and splice children in
        stack[stack.length - 1].children.push(...toAst(t.children).children);
      } else {
        stack[stack.length - 1].children.push({
          type: "text",
          content: t.content,
        });
      }
    } else if (t.nesting === -1) {
      stack.pop();
    }
  }

  return root;
}

const md = markdownit();

export function parseMarkdownLine(line: string): ElementNode {
  return toAst(md.parse(line, {}));
}
